export default "https://cdn-static.gokick.com/assets/e693edcab6ba034c0ea6bea85be7a795ed1fbf27/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";